import React from 'react'
import { Modal, Button } from 'app/components';
import './style';

const SuccessModal = ({onConfirm, isOpen }) => {
  return (
    <div>
      <Modal
        isOpen={isOpen}
        className="success-modal pt-0"
        size="regular"
        title={null}
        children=<div className='flex flex-col items-center justify-center gap-8'> 
          <img src="/assets/images/success.svg"
            alt="success"
            loading='lazy'/>
          <div className="flex flex-col gap-3 items-center text-center ">
            <div className="heading-24 ">Your event has been successfully submitted for review!</div>
            <div className="text-16 px-16">Our team will notify you by mail within 60 mins once the event is made live.</div>
          </div>
          <Button
            type="primary-black"
            children={'Got it'}
            onClick={onConfirm}
            className='w-full'
          />
        
        </div>
        
      />
    </div>
  )
}

export default SuccessModal